import axios from '../../config/axiosConfig';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SET_FIN_YEAR, SET_TOKEN_USER, SET_COMPANY, SET_CUSTOMER, SET_SUPER_USER, SET_USER } from '../types';
import { getCompanies } from './company-actions';

const autoSelectFinyearCompany = (finyear, company, finyears, companies) => {
    let state = { finyear, company };
    if (finyear?.id) {
        if (finyears?.length) {
            const index = finyears.findIndex((data) => data === finyear.id);
            if (index < 0) {
                state = { ...state, finyear: null, company: null };
            } else if (company?.id && companies?.length) {
                const cIndex = companies.findIndex((data) => data === company.id)
                if (cIndex < 0) {
                    state = { ...state, company: null };
                }
            } else {
                state = { ...state, company: null };
            }
        } else {
          state = { ...state, finyear: null, company: null };
        }
    } else {
      state = { ...state, finyear: null, company: null };
    }
    return state;
}

export const getPrivacyPolicy = () => {
    return async () => {
        try {
            return axios.get('policy/privacy-policy').then((response) => {
                if (response.data) {
                    return response?.data;
                }
            }).catch((error) => {
                throw error;
            });
        } catch (error) {
            throw error;
        }
    };
};

export const loginUser = (credentials) => {
    return async (dispatch) => {
        dispatch({ type: LOGIN_REQUEST });
        try {
            return axios.post('/auth/login', credentials).then((response) => {
                if (response.data?.token) {
                    let user = {};
                    if (response.data.user.Role === "Super Admin" && !response.data.user.Created_User) {
                        user = { superUser: response.data.user, finyear: null, company: null, token: response.data.token };
                        dispatch({ type: LOGIN_SUCCESS, payload: user });
                    } else {
                        user = { ...response.data };
                        dispatch({ type: LOGIN_SUCCESS, payload: { ...user } });
                        dispatch(getCompanies());
                    }
                } else {
                    dispatch({ type: LOGIN_FAILURE, error: response?.data?.error || response.data?.message });      
                }
            }).catch((error) => {
                dispatch({ type: LOGIN_FAILURE, error: error.response?.data?.error || error.message });
                throw error;
            });
        } catch (error) {
            dispatch({ type: LOGIN_FAILURE, error: error.response?.data?.error || error.message });
            throw error;
        }
    };
};

export const logoutUser = () => {
    return async (dispatch) => {
        localStorage.removeItem("persist:auth");
        dispatch({ type: SET_TOKEN_USER, payload: { token: null } });
        dispatch({ type: SET_FIN_YEAR, payload: null });
        dispatch({ type: SET_COMPANY, payload: null });
    };
};

export const setToken = (token) => {
    return async (dispatch) => {
        try {
            dispatch({ type: LOGIN_REQUEST });
            return axios.get('/auth/user', { params: { token } }).then((response) => {
                return axios.get('/auth/customer', { params: { token } }).then((custRes) => {
                    if (response.data?.user && custRes.data) {
                        dispatch({ type: SET_TOKEN_USER, payload: { token, user: response.data?.user, customer: response.data?.customer } });
                    } else {
                        dispatch({ type: LOGIN_FAILURE, error: response.data?.error });
                    }
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: LOGIN_FAILURE, error: error.message });
                    throw error;
                });
            }).catch((error) => {
                console.error(error);
                dispatch({ type: LOGIN_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            dispatch({ type: LOGIN_FAILURE, error: error.message });
            throw error;
        }
    }
}

export const getLatestAuth = () => {
    return async (dispatch, getState) => {
        const { auth: { token, customer, user, finyear, company, superUser } = {} } = getState();
        try {
            if (token) {
                return axios.get('/auth/get-auth',
                    { params: { customerId: customer?.id, userId: user?.id, finyearId: finyear?.id, companyId: company?.id, superUserId: superUser?.id } })
                    .then(({ data }) => {
                        if (data?.finyear) {
                            dispatch({ type: SET_FIN_YEAR, payload: data.finyear });
                        }
                        if (data?.company) {
                            dispatch({ type: SET_COMPANY, payload: data.company });
                        }
                        if (data?.customer) {
                            dispatch({ type: SET_CUSTOMER, payload: data.customer });
                        }
                        if (data?.user) {
                            dispatch({ type: SET_USER, payload: data.user });
                        }
                        if (data?.superUser) {
                            dispatch({ type: SET_SUPER_USER, payload: data.superUser });
                            dispatch({ type: SET_CUSTOMER, payload: null });
                            dispatch({ type: SET_FIN_YEAR, payload: null });
                            dispatch({ type: SET_COMPANY, payload: null });
                        }
                    }).catch((error) => {
                        console.error(error);
                        throw error;
                    });
            }
        } catch (e) {
            console.error('Failed to load latest auth reducer', e);
            throw e;
        }
    }
}

export const getAuthFinyearsCompanies = () => {
    return async (dispatch) => {
        try {
            return axios.get('/auth/finyears-companies').then((response) => {
                return response?.data;
            }).catch((error) => {
                throw error;
            });
        } catch (error) {
            throw error;
        }
    };
};

export const setFinyear = (finyear) => {
    return async (dispatch) => {
        dispatch({ type: SET_FIN_YEAR, payload: finyear });
    }
}

export const setCompany = (company) => {
    return async (dispatch) => {
        dispatch({ type: SET_COMPANY, payload: company });
    }
}
